export default __webpack_public_path__ + "82a53579cedb4011592d4320c84f6d07.woff2";